/**
 * Payload do cadastro generico: so os campos declarados, com o tipo que a API espera.
 * O ValidationPipe da API usa whitelist + forbidNonWhitelisted e nao converte 'true' em
 * boolean; mandar o registro inteiro (id, codigo, createdAt...) ou o texto do select volta 400.
 */
export interface CampoPayload {
  name: string;
  valueType?: 'text' | 'number' | 'boolean';
  /** Campo que existe no Criar*Dto mas nao no Atualizar*Dto (ex.: codigo, sigla). */
  apenasNaCriacao?: boolean;
}

export type ModoCadastro = 'criar' | 'editar';

function converter(valor: unknown, tipo: CampoPayload['valueType']): unknown {
  if (valor === undefined || valor === null) return undefined;

  if (tipo === 'boolean') {
    if (valor === true || valor === 'true') return true;
    if (valor === false || valor === 'false') return false;
    return undefined;
  }

  if (typeof valor === 'string') {
    const texto = valor.trim();
    if (texto === '') return undefined;
    if (tipo === 'number') {
      const numero = Number(texto);
      // Texto nao numerico segue como veio: a API responde 400, nada e descartado em silencio.
      return Number.isFinite(numero) ? numero : texto;
    }
    return texto;
  }

  return valor;
}

export function montarPayloadCadastro(
  campos: readonly CampoPayload[],
  valores: Record<string, unknown>,
  modo: ModoCadastro,
): Record<string, unknown> {
  const payload: Record<string, unknown> = {};
  for (const campo of campos) {
    if (modo === 'editar' && campo.apenasNaCriacao) continue;
    const valor = converter(valores[campo.name], campo.valueType);
    if (valor !== undefined) payload[campo.name] = valor;
  }
  return payload;
}
